/* eslint-disable */
import axios from './request'

// 获取下订用户订单list
export function fetchOrderList(ids) {
  return axios.get('/bingo/h5/promotion/cms/getothersingleorderlist', {})
}
